import { Component, OnDestroy, OnInit } from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativeDetailV2Component } from '../creative-detail-v2/creative-detail-v2.component';
import {
	CreativeAdSize,
	CreativeDetail,
	VideoCompletionPercentage
} from '../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-ctv-creative-detail-v2',
	styleUrls: ['./ctv-creative-detail-v2.component.css'],
	templateUrl: './ctv-creative-detail-v2.component.html'
})
export class CtvCreativeDetailV2Component extends CreativeDetailV2Component implements OnInit, OnDestroy {
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected modalService: ModalService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, modalService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	mapResponseToInterface(responseData: any): void {
		let counter = 0;
		for (const responseObj of responseData) {
			const creativeObj: CreativeDetail = {} as CreativeDetail;
			creativeObj.adInteractions = UtilityService.isUndefinedOrNull(responseObj.ad_interactions)
				? 0
				: parseInt(responseObj.ad_interactions, 10);
			creativeObj.adInteractionRate = UtilityService.isUndefinedOrNull(responseObj.interaction_rate)
				? 0
				: parseFloat(responseObj.interaction_rate).toFixed(2);
			creativeObj.impressions = UtilityService.isUndefinedOrNull(responseObj.impressions)
				? 0
				: parseInt(responseObj.impressions, 10);
			creativeObj.clickRate = undefined;
			creativeObj.clicks = undefined;
			creativeObj.versionId = UtilityService.isUndefinedOrNull(responseObj.cup_version_id)
				? 0
				: parseInt(responseObj.cup_version_id, 10);
			creativeObj.creativeName = responseObj.name;
			creativeObj.creativeThumbnail = UtilityService.isUndefinedOrNull(responseObj.thumbnail)
				? this.placeholderimage
				: responseObj.thumbnail;
			creativeObj.htmlClass = this.getClassByIndex(counter);
			creativeObj.isVideoCreative = !UtilityService.isUndefined(
				responseObj.mp4 ? responseObj.mp4 : responseObj.video_url
			);
			creativeObj.isAudioCreative = !UtilityService.isUndefinedOrNull(responseObj.audio_url);
			creativeObj.audioURL = responseObj.audio_url ? responseObj.audio_url : false;
			creativeObj.adSizes =
				!creativeObj.isVideoCreative && !creativeObj.isAudioCreative
					? this.mapResponseToAdSizes(responseObj.creatives_by_ads ? responseObj.creatives_by_ads : [])
					: ({} as { string: CreativeAdSize });
			creativeObj.hasAdSizes =
				!creativeObj.isVideoCreative && !creativeObj.isAudioCreative ? !!responseObj.creatives_by_ads : false;
			if (creativeObj.isVideoCreative || creativeObj.isAudioCreative) {
				if (creativeObj.isVideoCreative) {
					creativeObj.creativeVideo = responseObj.mp4;
					if (responseObj.mp4 === null || responseObj.mp4 === '') {
						creativeObj.creativeVideo = this.getMp4FromMediaFilesJson(responseObj.media_files);
					}
					if (creativeObj.creativeVideo === null && responseObj.video_url !== '') {
						creativeObj.creativeVideo = responseObj.video_url;
					}
				}
				creativeObj.audioURL = creativeObj.isAudioCreative ? responseObj.audio_url : '';
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(responseObj['100_percent_rate'])
					? 0
					: parseFloat(responseObj['100_percent_rate']).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(responseObj['100_percent_value'])
					? 0
					: parseInt(responseObj['100_percent_value'], 10);

				let videoCompletionPercentage: VideoCompletionPercentage = {} as VideoCompletionPercentage;
				videoCompletionPercentage.started = 100;
				videoCompletionPercentage.completed = UtilityService.isUndefinedOrNull(responseObj['100_percent_rate'])
					? 0
					: parseFloat(responseObj['100_percent_rate']).toFixed(2);
				videoCompletionPercentage.completionValue = UtilityService.isUndefinedOrNull(responseObj['100_percent_value'])
					? 0
					: parseInt(responseObj['100_percent_value'], 10);
				videoCompletionPercentage.quarter = UtilityService.isUndefinedOrNull(responseObj['25_percent_rate'])
					? 0
					: parseFloat(responseObj['25_percent_rate']).toFixed(2);
				videoCompletionPercentage.quarterValue = UtilityService.isUndefinedOrNull(responseObj['25_percent_value'])
					? 0
					: parseInt(responseObj['25_percent_value'], 10);
				videoCompletionPercentage.half = UtilityService.isUndefinedOrNull(responseObj['50_percent_rate'])
					? 0
					: parseFloat(responseObj['50_percent_rate']).toFixed(2);
				videoCompletionPercentage.halfValue = UtilityService.isUndefinedOrNull(responseObj['50_percent_value'])
					? 0
					: parseInt(responseObj['50_percent_value'], 10);
				videoCompletionPercentage.threeQuarters = UtilityService.isUndefinedOrNull(responseObj['75_percent_rate'])
					? 0
					: parseFloat(responseObj['75_percent_rate']).toFixed(2);
				videoCompletionPercentage.threeQuartersValue = UtilityService.isUndefinedOrNull(responseObj['75_percent_value'])
					? 0
					: parseInt(responseObj['75_percent_value'], 10);
				videoCompletionPercentage = this.addVideoCompletionTooltip(videoCompletionPercentage);
				creativeObj.videoCompletionPercentage = videoCompletionPercentage;
			}
			this.creatives.push(creativeObj);
			counter++;
		}
	}
}
